import { render, staticRenderFns } from "./Waves.vue?vue&type=template&id=c2f532e4&scoped=true"
import script from "./Waves.vue?vue&type=script&lang=js"
export * from "./Waves.vue?vue&type=script&lang=js"
import style0 from "./Waves.vue?vue&type=style&index=0&id=c2f532e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f532e4",
  null
  
)

export default component.exports